<div
    class="cmps-cdk-d-flex cmps-cdk-flex-wrap cmps-cdk-align-items-center cmps-cdk-mb-1dot5"
>
    <div
        class="cmps-cdk-flex-100 cmps-cdk-flex-lg-50 cmps-cdk-mb-0dot5 cmps-cdk-mb-lg-0 cmps-eval-landing--title"
    >
        {{ _i18n._139_EVALUATIONS | translate }}
    </div>
    <div
        class="cmps-cdk-d-flex cmps-cdk-flex-wrap cmps-cdk-flex-100 cmps-cdk-flex-lg-50 cmps-cdk-justify-content-lg-flex-end"
    >
        <div class="cmps-cdk-mr-0dot5">
            <button
                cmpsButton
                (click)="_onCreateNewEvalClick()"
                *ngIf="state?.allowedActions?.create"
            >
                <cmps-icon svgIcon="file-plus-outline"></cmps-icon>
                <span cmpsButtonLabel>{{
                    _i18n._10021_CREATE_NEW_EVALUATION | translate
                }}</span>
            </button>
        </div>
        <button
            cmpsButton
            (click)="_onSearchEvalsClick()"
            *ngIf="state?.allowedActions?.search"
        >
            <cmps-icon svgIcon="magnify"></cmps-icon>
            <span cmpsButtonLabel>{{
                _i18n._10022_SEARCH_EVALUATIONS | translate
            }}</span>
        </button>
    </div>
</div>

<div class="cmps-cdk-d-flex cmps-cdk-flex-wrap">
    <div class="cmps-cdk-flex-100">
        <cmps-card-next>
            <cmps-card-header-next>
                {{ _i18n._10023_MY_EVALUATIONS | translate }}
            </cmps-card-header-next>
            <cmps-card-body-next class="cmps-eval-landing--body">
                <ng-container *ngFor="let g of state?.gridOrder">
                    <cmps-card-next
                        [collapsable]="true"
                        [collapsed]="state?.forMe?.collapsed"
                        [collapseMethod]="'v-hidden'"
                        *ngIf="g === _GridType.FOR_ME"
                    >
                        <cmps-card-header-next>
                            <div
                                class="cmps-cdk-d-flex cmps-cdk-align-items-center"
                            >
                                <div class="cmps-cdk-flex-50">
                                    {{
                                        _i18n._10024_EVALUATIONS_CREATED_FOR_ME
                                            | translate
                                    }}&nbsp; ({{ state?.forMe?.rows?.length }})
                                </div>
                                <div
                                    class="cmps-cdk-flex-50 cmps-cdk-d-flex cmps-cdk-justify-content-flex-end"
                                >
                                    <ng-container
                                        *ngTemplateOutlet="
                                            daysTpl;
                                            context: {
                                                grid: _GridType.FOR_ME,
                                                value: state?.forMe?.days
                                            }
                                        "
                                    ></ng-container>
                                </div>
                            </div>
                        </cmps-card-header-next>
                        <cmps-card-body-next>
                            <ng-container
                                *ngTemplateOutlet="
                                    gridContentTpl;
                                    context: {
                                        grid: _GridType.FOR_ME,
                                        opts: state?.forMe,
                                        data: _forMeTableData
                                    }
                                "
                            ></ng-container>
                        </cmps-card-body-next>
                    </cmps-card-next>

                    <cmps-card-next
                        [collapsable]="true"
                        [collapsed]="state?.byMe?.collapsed"
                        [collapseMethod]="'v-hidden'"
                        *ngIf="
                            g === _GridType.BY_ME &&
                            state?.allowedActions?.create
                        "
                    >
                        <cmps-card-header-next>
                            <div
                                class="cmps-cdk-d-flex cmps-cdk-align-items-center"
                            >
                                <div class="cmps-cdk-flex-50">
                                    {{
                                        _i18n._10025_EVALUATIONS_CREATED_BY_ME
                                            | translate
                                    }}&nbsp; ({{ state?.byMe?.rows?.length }})
                                </div>
                                <div
                                    class="cmps-cdk-flex-50 cmps-cdk-d-flex cmps-cdk-justify-content-flex-end"
                                >
                                    <ng-container
                                        *ngTemplateOutlet="
                                            daysTpl;
                                            context: {
                                                grid: _GridType.BY_ME,
                                                value: state?.byMe?.days
                                            }
                                        "
                                    ></ng-container>
                                </div>
                            </div>
                        </cmps-card-header-next>
                        <cmps-card-body-next>
                            <ng-container
                                *ngTemplateOutlet="
                                    gridContentTpl;
                                    context: {
                                        grid: _GridType.BY_ME,
                                        opts: state?.byMe,
                                        data: _byMeTableData
                                    }
                                "
                            ></ng-container>
                        </cmps-card-body-next>
                    </cmps-card-next>

                    <cmps-card-next
                        [collapsable]="true"
                        [collapsed]="state?.forMyTeam?.collapsed"
                        [collapseMethod]="'v-hidden'"
                        *ngIf="
                            g === _GridType.FOR_MY_TEAM &&
                            state?.allowedActions?.hasForMyTeamContainer
                        "
                    >
                        <cmps-card-header-next>
                            <div
                                class="cmps-cdk-d-flex cmps-cdk-flex-wrap cmps-cdk-align-items-center"
                            >
                                <div
                                    class="cmps-cdk-flex-100 cmps-cdk-flex-xl-50 cmps-cdk-mb-0dot5 cmps-cdk-mb-xl-0"
                                >
                                    {{
                                        _i18n._10026_EVALUATIONS_CREATED_FOR_MY_TEAM
                                            | translate
                                    }}&nbsp; ({{
                                        state?.forMyTeam?.rows?.length
                                    }})
                                </div>
                                <div
                                    class="cmps-cdk-d-flex cmps-cdk-flex-wrap cmps-cdk-flex-100 cmps-cdk-flex-xl-50 cmps-cdk-justify-content-xl-flex-end"
                                >
                                    <div
                                        class="cmps-cdk-mr-1dot5"
                                        *ngIf="
                                            state?.allowedActions
                                                ?.hasForMyTeamTeamAndSubordinateButton
                                        "
                                    >
                                        <cmps-button-group
                                            (click)="$event.stopPropagation()"
                                            [ngModel]="
                                                state?.forMyTeam?.teamAlt
                                            "
                                            (ngModelChange)="
                                                _onTeamGridAltChange($event)
                                            "
                                        >
                                            <button
                                                cmpsButtonGroupItem
                                                [value]="_TeamAlt.TEAM"
                                            >
                                                {{
                                                    _i18n._7471_TEAM | translate
                                                }}
                                            </button>
                                            <button
                                                cmpsButtonGroupItem
                                                [value]="
                                                    _TeamAlt.TEAM_AND_SUBORDINATES
                                                "
                                            >
                                                {{
                                                    _i18n._10027_TEAM_SUBORDINATES
                                                        | translate
                                                }}
                                            </button>
                                        </cmps-button-group>
                                    </div>
                                    <ng-container
                                        *ngTemplateOutlet="
                                            daysTpl;
                                            context: {
                                                grid: _GridType.FOR_MY_TEAM,
                                                value: state?.forMyTeam?.days
                                            }
                                        "
                                    ></ng-container>
                                </div>
                            </div>
                        </cmps-card-header-next>
                        <cmps-card-body-next>
                            <ng-container
                                *ngTemplateOutlet="
                                    gridContentTpl;
                                    context: {
                                        grid: _GridType.FOR_MY_TEAM,
                                        opts: state?.forMyTeam,
                                        data: _forMyTeamTableData
                                    }
                                "
                            ></ng-container>
                        </cmps-card-body-next>
                    </cmps-card-next>
                </ng-container>
            </cmps-card-body-next>
        </cmps-card-next>
    </div>
</div>

<router-outlet></router-outlet>

<ng-template
    let-g="grid"
    let-v="value"
    #daysTpl
>
    <cmps-button-group
        (click)="$event.stopPropagation()"
        [ngModel]="v"
        (ngModelChange)="_onGridDateRangeChange(g, $event)"
    >
        <button
            cmpsButtonGroupItem
            [value]="_GridDays._30"
        >
            {{ _GridDays._30 }} {{ _i18n._830_DAY | translate }}
        </button>
        <button
            cmpsButtonGroupItem
            [value]="_GridDays._60"
        >
            {{ _GridDays._60 }} {{ _i18n._830_DAY | translate }}
        </button>
        <button
            cmpsButtonGroupItem
            [value]="_GridDays._90"
        >
            {{ _GridDays._90 }} {{ _i18n._830_DAY | translate }}
        </button>
    </cmps-button-group>

    <button
        class="cmps-cdk-ml-0dot5 cmps-button--sm"
        cmpsButton
        (click)="$event.stopPropagation(); _onResetClick(g)"
    >
        <cmps-icon svgIcon="cached"></cmps-icon>
        <span cmpsButtonLabel>{{ _i18n._9395_RESET_GRID | translate }}</span>
    </button>
</ng-template>

<ng-template
    let-g="grid"
    let-o="opts"
    let-d="data"
    #gridContentTpl
>
    <div>
        <!--ngGrid will measure this div-->
        <div
            ngGrid
            class="cmps-eval-landing-table"
            [rendererOptions]="d?.rendererOpts"
            [selectTemplate]="d?.selectTpl"
            [rows]="d?.rows"
            [sortDefs]="d?.sortDefs"
            [dataRows]="o?.rows"
            [filteredDataRows]="o?.filteredRows"
            *ngIf="o?.rows?.length > 0"
        >
            <ng-template
                gridContent
                data-type="grid"
            >
                <div></div>
            </ng-template>

            <ng-template
                gridContent
                data-type="row"
                data-id="header"
            >
                <div class="cmps-eval-landing-table--row-header"></div>
            </ng-template>

            <ng-template
                gridContent
                data-type="cell"
                data-id="header"
                let-c="c"
                let-ctx="ctx"
            >
                <div>
                    <div
                        [ngClass]="
                            'cmps-eval-landing-table--row-header--' +
                            ctx?.data?.classSuffix
                        "
                    >
                        <button
                            class="cmps-eval-landing-table--row-header--button"
                            (click)="_onColumnSortClick(g, c)"
                            *ngIf="c.id !== _ColumnId.SELECT"
                        >
                            <span class="cmps-eval-landing-table--row--text">{{
                                ctx?.data?.label | translate
                            }}</span>

                            <!--putting buttons inside buttons isn't nice-->
                            <button
                                class="cmps-icon-button--no-bg cmps-icon-button--sm cmps-cdk-mr-auto"
                                [class.cmps-eval-landing-table--row-header--button--filter]="
                                    ctx?.isFilterActive
                                "
                                cmpsIconButton
                                [cmpsOverlayTrigger]="filterTpl"
                                placement="bottom-left"
                                (click)="$event.stopPropagation()"
                                *ngIf="ctx?.filterOpts?.length > 0"
                            >
                                <cmps-icon svgIcon="filter"></cmps-icon>
                            </button>

                            <cmps-icon
                                [svgIcon]="
                                    o?.sortOptions?.columnId !== c.id
                                        ? 'unfold-more-horizontal'
                                        : o?.sortOptions?.order ===
                                          _SortOrder.ASC
                                        ? 'chevron-up'
                                        : 'chevron-down'
                                "
                            ></cmps-icon>
                        </button>
                    </div>
                </div>

                <!--not able to pass context, so this is nested within this template-->
                <ng-template
                    let-overlay="overlay"
                    #filterTpl
                >
                    <cmps-text-filter
                        (textChange)="
                            _onTextFilterChange(ctx, o, $event, overlay)
                        "
                    >
                        <cmps-text-filter-header>
                            {{ _i18n._710_SEARCH | translate }}
                        </cmps-text-filter-header>
                        <ng-container
                            ngProjectAs="cmps-text-filter-item"
                            *ngFor="let opt of ctx?.filteredFilterOpts"
                        >
                            <cmps-text-filter-item
                                [class.cmps-text-filter-item-active]="
                                    opt.isSelected
                                "
                                (click)="
                                    overlay?.toggle();
                                    _onTextFilterItemClick(ctx, g, c, opt.value)
                                "
                            >
                                <cmps-icon
                                    *ngIf="opt.isSelected"
                                    svgIcon="check"
                                ></cmps-icon>
                                <span class="cmps-cdk-ml-0dot5">{{
                                    opt.label
                                }}</span>
                            </cmps-text-filter-item>
                        </ng-container>
                    </cmps-text-filter>
                </ng-template>
            </ng-template>

            <ng-template
                gridContent
                data-type="row"
                data-id="content"
            >
                <div class="cmps-eval-landing-table--row"></div>
            </ng-template>

            <ng-template
                gridContent
                data-type="cell"
                data-id="content"
                let-c="c"
                let-ctx="ctx"
            >
                <div [ngSwitch]="c.id">
                    <div
                        class="cmps-eval-landing-table--row--event-date"
                        *ngSwitchCase="_ColumnId.EVENT_DATE"
                    >
                        <span class="cmps-eval-landing-table--row--text">
                            {{
                                (ctx?.data?.eventDate
                                    | cmpsDate: 'yyyy-MM-dd') ?? '-'
                            }}
                        </span>
                    </div>
                    <div
                        class="cmps-eval-landing-table--row--evaluation-id"
                        *ngSwitchCase="_ColumnId.EVALUATION_ID"
                    >
                        <span class="cmps-eval-landing-table--row--text">{{
                            ctx?.data?.draftId != null
                                ? (_i18n._9476_DRAFT | translate)
                                : ctx?.data?.responseId
                        }}</span>
                    </div>
                    <div
                        class="cmps-eval-landing-table--row--user-name"
                        *ngSwitchCase="_ColumnId.USER_NAME"
                    >
                        <span class="cmps-eval-landing-table--row--text">{{
                            ctx?.data?.targetUserName ?? '-'
                        }}</span>
                    </div>
                    <div
                        class="cmps-eval-landing-table--row--manager"
                        *ngSwitchCase="_ColumnId.MANAGER"
                    >
                        <span class="cmps-eval-landing-table--row--text">{{
                            ctx?.data?.targetManagerUserName ?? '-'
                        }}</span>
                    </div>
                    <div
                        class="cmps-eval-landing-table--row--manager"
                        *ngSwitchCase="_ColumnId.EVALUATOR"
                    >
                        <span class="cmps-eval-landing-table--row--text">{{
                            ctx?.data?.evaluatorUserName ?? '-'
                        }}</span>
                    </div>
                    <div
                        class="cmps-eval-landing-table--row--evaluation-name"
                        *ngSwitchCase="_ColumnId.EVALUATION_NAME"
                    >
                        <span class="cmps-eval-landing-table--row--text">{{
                            ctx?.data?.evaluationName
                        }}</span>
                    </div>
                    <div
                        class="cmps-eval-landing-table--row--score"
                        *ngSwitchCase="_ColumnId.SCORE"
                    >
                        <span class="cmps-eval-landing-table--row--text">
                            {{
                                (ctx?.data?.percentage
                                    | cmpsPercent: '1.2-2') ?? '-'
                            }}
                        </span>
                    </div>
                    <div
                        class="cmps-eval-landing-table--row--status"
                        *ngSwitchCase="_ColumnId.STATUS"
                    >
                        <span class="cmps-eval-landing-table--row--text">
                            {{
                                (ctx?.data?.draftId != null
                                    ? _i18n._9476_DRAFT
                                    : _i18n._9113_PUBLISHED
                                ) | translate
                            }}
                        </span>
                    </div>
                    <div
                        class="cmps-eval-landing-table--row--select cmps-cdk-justify-content-center"
                        *ngSwitchCase="_ColumnId.SELECT"
                    >
                        <button
                            class="cmps-outline-button--sm cmps-outline-button--outline cmps-cdk-mx-0dot5"
                            cmpsOutlineButton
                            (click)="_onGridViewRowClick(ctx?.data)"
                        >
                            <cmps-icon svgIcon="eye"></cmps-icon>
                            <span cmpsOutlineButtonLabel>{{
                                _i18n._789_VIEW | translate
                            }}</span>
                        </button>
                        <button
                            class="cmps-outline-button--sm cmps-outline-button--outline--green cmps-cdk-mx-0dot5"
                            cmpsOutlineButton
                            (click)="_onGridEditRowClick(ctx?.data)"
                            *ngIf="
                                ctx?.data?.draftId != null
                                    ? state?.allowedActions?.editDraft
                                    : state?.allowedActions?.editPublish
                            "
                        >
                            <cmps-icon svgIcon="pencil"></cmps-icon>
                            <span cmpsOutlineButtonLabel>{{
                                _i18n._7425_EDIT | translate
                            }}</span>
                        </button>
                    </div>
                </div>
            </ng-template>
        </div>

        <div
            class="cmps-cdk-text-center"
            *ngIf="o?.rows?.length === 0"
        >
            {{
                _i18n._10031_NO_EVALUATIONS_TO_DISPLAY_FOR_THE_SELECTED_TIME_PERIOD
                    | translate
            }}
        </div>

        <div
            class="cmps-cdk-text-center cmps-cdk-mt-1dot5"
            *ngIf="o?.showAllEnabled"
        >
            <button
                cmpsButton
                (click)="_onGridToggleShowAllClick(g)"
            >
                <cmps-icon
                    [svgIcon]="o?.showAll ? 'minus' : 'plus'"
                ></cmps-icon>
                <span cmpsButtonLabel>{{
                    (o?.showAll ? _i18n._10028_SHOW_LESS : _i18n._4130_SHOW_ALL)
                        | translate
                }}</span>
            </button>
        </div>
    </div>
</ng-template>
